import { Component, OnInit, Input } from '@angular/core';
import { RoleService } from '../../../services/role/role.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { TokenStorage } from '../../../auth/token.storage';

@Component({
  selector: 'app-userrolemanage',
  templateUrl: './userrolemanage.component.html',
  styleUrls: ['./userrolemanage.component.scss']
})
export class UserrolemanageComponent implements OnInit {

  roleAdmin: FormGroup;
  roleCXO: FormGroup;
  roleManager: FormGroup;
  roleStoreManager: FormGroup;
  userId: string;
  roleName: string;
  roleId: number;
  disabled = true;
  isTenantDiag: boolean = false;

  constructor(
    public formBuilder: FormBuilder,
    public roleService: RoleService,
    public snackBar: MatSnackBar,
    public router: Router,
    private token: TokenStorage
  ) {

  }

  ngOnInit() {
    this.roleService.currentMessage.subscribe(data => {
      console.log(data);
      this.userId = data;
      if(data != null){
        this.disabled = false;
      }
    })

    if (this.token.getCustomerType() === 'Diagnostic')
        this.isTenantDiag = true;
    else
        this.isTenantDiag = false;
  }

  assignRoleAdmin(bAssign) {
    console.log(bAssign);
    let assignRoleData = {
      userId: this.userId,
      roleName: "Admin",
      roleId: 1,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleCxo(bAssign) {
    let assignRoleData = {
      userId: this.userId,
      roleName: "CXO",
      roleId: 2,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleWarehouseManager(bAssign) {
    let assignRoleData = {
      userId: this.userId,
      roleName: "Warehouse_Manager",
      roleId: 3,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleStoreManager(bAssign) {

    let assignRoleData = {
      userId: this.userId,
      roleName: "Store_Manager",
      roleId: 4,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleDeliveryAssociate(bAssign) {

    let assignRoleData = {
      userId: this.userId,
      roleName: "Delivery_Associate",
      roleId: 5,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleMarketing(bAssign) {

    let assignRoleData = {
      userId: this.userId,
      roleName: "Marketing",
      roleId: 6,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleRunnerBoyManager(bAssign) {
    let assignRoleData = {
      userId: this.userId,
      roleName: "Runner_Boy_Admin",
      roleId: 9,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  assignRoleHomeCollectionManager(bAssign)  {
    let assignRoleData = {
      userId: this.userId,
      roleName: "Home_Collection_Admin",
      roleId: 8,
      bAssign: bAssign
    }

    console.log(assignRoleData);

    this.roleService.assignRoleToUser(assignRoleData).subscribe(res => {
      console.log(res);
      if (bAssign) {
        this.snackBar.open("User role has been assigned", "ok", {
          duration: 2000
        })
      } else {
        this.snackBar.open("User role has been revoked", "ok", {
          duration: 2000
        })
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/userandrole/assignrole"]));
    });
  }

  ngOnDestroy(){
    this.roleService.messageSource.next(null);
  }

}


